// AdminDashboardHome.js
// Sandbox URL: https://sandbox-schools.articulate.com.sg/admin
// Prod URL: https://schools.articulate.com.sg/admin

import React from "react";
import { useOutletContext } from "react-router-dom";
import "./AdminDashboard.css";

export default function AdminDashboardHome() {
  const outletContext = useOutletContext() || {};
  const adminEmail = outletContext.adminEmail || "";

  return (
    <div className="admin-card">
      <h2 className="admin-section-title">Admin Dashboard</h2>
      <p>Use Users to look up a user by WhatsApp number.</p>
      <p>Use Credit Activity to review public credit usage, purchases and adjustments.</p>
      <p>Use Chat to open a support conversation and manual override.</p>
      {adminEmail && <div className="admin-meta">Current admin: {adminEmail}</div>}
    </div>
  );
}
